/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCorrectExamAnsweridQueryResponse,
  GetApiV1ExamCorrectExamAnsweridPathParams,
  GetApiV1ExamCorrectExamAnswerid400,
  GetApiV1ExamCorrectExamAnswerid401,
  GetApiV1ExamCorrectExamAnswerid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectExamAnswerid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCorrectExamAnswerid } from "../../clients/examCorrectionDashboardController/getApiV1ExamCorrectExamAnswerid.ts";

export const getApiV1ExamCorrectExamAnsweridQueryKey = (
  answerId: GetApiV1ExamCorrectExamAnsweridPathParams["answerId"],
) =>
  [
    {
      url: "/api/v1/exam/correct-exam/:answerId",
      params: { answerId: answerId },
    },
  ] as const;

export type GetApiV1ExamCorrectExamAnsweridQueryKey = ReturnType<
  typeof getApiV1ExamCorrectExamAnsweridQueryKey
>;

export function getApiV1ExamCorrectExamAnsweridQueryOptions(
  answerId: GetApiV1ExamCorrectExamAnsweridPathParams["answerId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCorrectExamAnsweridQueryKey(answerId);
  return queryOptions<
    GetApiV1ExamCorrectExamAnsweridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectExamAnswerid400
      | GetApiV1ExamCorrectExamAnswerid401
      | GetApiV1ExamCorrectExamAnswerid500
    >,
    GetApiV1ExamCorrectExamAnsweridQueryResponse,
    typeof queryKey
  >({
    enabled: !!answerId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCorrectExamAnswerid(answerId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna o modelo de correção de texto para uma resposta específica do exame. **(Requer Authorization para autenticação)**
 * @summary Obtenha o modelo de correção de exame (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correct-exam/:answerId}
 */
export function useGetApiV1ExamCorrectExamAnswerid<
  TData = GetApiV1ExamCorrectExamAnsweridQueryResponse,
  TQueryData = GetApiV1ExamCorrectExamAnsweridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamCorrectExamAnsweridQueryKey,
>(
  answerId: GetApiV1ExamCorrectExamAnsweridPathParams["answerId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCorrectExamAnsweridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCorrectExamAnswerid400
          | GetApiV1ExamCorrectExamAnswerid401
          | GetApiV1ExamCorrectExamAnswerid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamCorrectExamAnsweridQueryKey(answerId);

  const query = useQuery(
    {
      ...getApiV1ExamCorrectExamAnsweridQueryOptions(answerId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectExamAnswerid400
      | GetApiV1ExamCorrectExamAnswerid401
      | GetApiV1ExamCorrectExamAnswerid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
